import type { ComponentProps } from 'react'

import { Breadcrumb, type BreadcrumbSegment } from '@/ui/breadcrumb'

import { useSelectedEntity } from './lib/entity-queries'

type EntityBreadcrumbProps = Omit<
  ComponentProps<typeof Breadcrumb>,
  'segments'
> & {
  path: string
  segments: BreadcrumbSegment[]
}

export function EntityBreadcrumb({
  path,
  segments,
  ...props
}: EntityBreadcrumbProps) {
  const { ancestors } = useSelectedEntity()
  const entitySegments = (ancestors.data?.items ?? []).map((entity) => ({
    label: entity.name,
    href: `/${entity.entityId}/${path}`,
  }))

  return <Breadcrumb {...props} segments={[...entitySegments, ...segments]} />
}
